import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TemplateSelection } from "./templateTypes";

export const samTemplateSliceName = "samTemplate";

export interface SamTemplateState {
  selection: TemplateSelection;
  selectByBaseNumbers: string[] | undefined;
}

const initialState: SamTemplateState = {
  selection: { nodeIds: [] },
  selectByBaseNumbers: undefined,
};

const samSlice = createSlice({
  name: samTemplateSliceName,
  initialState,
  reducers: {
    setTemplateSelection(state: SamTemplateState, action: PayloadAction<TemplateSelection>) {
      state.selection = action.payload;
    },
    setTemplateSelectByBaseNumbers(state: SamTemplateState, action: PayloadAction<string[] | undefined>) {
      state.selectByBaseNumbers = action.payload;
    },
  },
});

export interface SamTemplateRootState {
  [samTemplateSliceName]: SamTemplateState;
}

export const selectSamTemplate = (state: SamTemplateRootState) => state[samTemplateSliceName];
export const selectSamTemplateSelection = (state: SamTemplateRootState) => {
  return selectSamTemplate(state).selection;
};
export const selectSamTemplateSelectByBaseNumbers = (state: SamTemplateRootState) => {
  return selectSamTemplate(state).selectByBaseNumbers;
};

export const { setTemplateSelection, setTemplateSelectByBaseNumbers } = samSlice.actions;
export const samTemplateReducer = samSlice.reducer;
